import { ICardProps, Intent, Tag } from '@blueprintjs/core'
import * as React from 'react'
import { LogoChip } from '../../../../../../components/LogoChip'
import { channelById } from '../../../../../../constants/Channels'
import { UprightStyle } from '../../../../../../types'
import { rgbaForIntent } from '../../../../../../utils/color'

interface Props extends ICardProps {
  intent?: Intent
  channelId: number
  labelText?: string
  dashedBorder?: boolean
}

const styles: UprightStyle = {
  cardStyle: {
    display: 'grid',
    gridTemplateColumns: '44px 3fr minmax(0, auto)',
    gridColumnGap: 20,
    alignItems: 'flex-start',
    textAlign: 'left',
    position: 'relative',
    padding: 10,
    border: 'none'
  },
  label: {
    position: 'absolute',
    right: 20,
    bottom: 8
  },
  actionToolbar: {
    alignSelf: 'flex-start',
    display: 'flex'
  }
}

export const ChannelCard: React.FC<Props> = props => {
  const channel = channelById(props.channelId)
  const cardStyle = React.useMemo(() => {
    if (!props.labelText && !props.intent) return styles.cardStyle

    const fallbackIntent = props.labelText ? Intent.NONE : null
    const borderStyle = props.dashedBorder ? 'dashed' : 'solid'

    return {
      ...styles.cardStyle,
      border: `${borderStyle} 2px ${rgbaForIntent(props.intent || fallbackIntent, 0.5)}`
    }
  }, [props.intent, props.labelText])

  return (
    <div style={cardStyle}>
      <LogoChip name={channel.name} size={44} humanReadableName={channel.humanReadableName} />
      {props.children}
      {props.labelText && (
        <Tag style={styles.label} intent={props.intent} minimal>
          {props.labelText}
        </Tag>
      )}
    </div>
  )
}
